module.exports = __webpack_public_path__ + "static/malachite-5cf54f1340b3630e6be402b9291ba58b.svg";